export default __webpack_public_path__ + "static/media/we.e70931d6.jpg";